export default {"src":"/_next/static/media/auth-toast-error-icon.05857d81.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};